"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getEditorialLandingPageData = void 0;
var _presentationHttp = require("@ori/presentation-http");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _getEditorialLandingPage = require("./getEditorialLandingPage");
/**
 * Function calls fetch functions and returns data needed for editorial landing page.
 */ const getEditorialLandingPageData = async (param)=>{
    let { applicationName, language, graphQlUrl, pageId, staticApiUrl, tenant, token, customerTypeId } = param;
    const staticApiClient = new _staticApiClientReact.ApiClient({
        baseUrl: staticApiUrl,
        language,
        tenant
    });
    const headers = (0, _presentationHttp.getHeaders)({
        sourceAppName: applicationName,
        language,
        tenant,
        token,
        customerTypeId
    });
    const [breadcrumbs, editorialLandingPageData] = await Promise.all([
        (0, _presentationHttp.getBreadcrumbs)({
            language,
            pageId,
            staticApiClient,
            tenant
        }),
        (0, _getEditorialLandingPage.getEditorialLandingPage)({
            graphQlUrl,
            headers,
            pageId
        })
    ]);
    return {
        breadcrumbs,
        editorialLandingPageData
    };
};
exports.getEditorialLandingPageData = getEditorialLandingPageData;
